import '../Filter/Filter.scss';
import Component from './InvestorListFilter.js';
export default Component;
